<template>
  <div class="material-library">
    <div class="search" v-if="!isLimit">
      <van-search v-model="filter.name" show-action shape="round" clearable @search="onSearch" @clear="onSearch" placeholder="请输入搜索关键词">
        <template #action>
          <div @click="onSearch" :style="{ color: filter.name ? '#277fff' : '' }" class="search-text">搜索</div>
        </template>
      </van-search>
    </div>
    <div class="search-drop">
      <div class="condition">
        <van-tag v-for="item in checkedList.slice(0, 4)" :key="item.id" color="#E3EFFF" size="large" text-color="#277fff">{{ item.name }}</van-tag>
      </div>
      <van-dropdown-menu active-color="#3d3d3d" :close-on-click-outside="false">
        <van-icon name="filter-o" class="filter-icon" />
        <van-dropdown-item title="筛选" ref="item" class="arrow-sear">
          <div style="flex: 1; overflow-y: scroll; padding-bottom: 40px">
            <div class="type-list">
              <p>素材类型</p>
              <ul>
                <li v-for="(item, index) in typeList" :class="{ activeType: typeIndex === index }" :key="item.id" @click="handleIndex(1, item, index)">
                  {{ item.name }}
                </li>
              </ul>
            </div>
            <div class="file-list">
              <p>文件类型</p>
              <ul>
                <li v-for="(item, index) in fileList" :class="{ activeFile: fileIndex === index }" :key="item.id" @click="handleIndex(2, item, index)">
                  {{ item.name }}
                </li>
              </ul>
            </div>
            <van-collapse v-model="activeNames">
              <van-collapse-item v-for="(item, index) in labelsList" :key="item.groupId" :title="item.groupName" :name="item.groupId">
                <ul>
                  <li
                    v-for="(item2, index2) in item.labels"
                    :key="item2.labelId"
                    :class="[
                      index === 0
                        ? labelIndex_0 === index2
                          ? 'labelIndex'
                          : ''
                        : index === 1
                        ? labelIndex_1 === index2
                          ? 'labelIndex'
                          : ''
                        : index === 2
                        ? labelIndex_2 === index2
                          ? 'labelIndex'
                          : ''
                        : index === 3
                        ? labelIndex_3 === index2
                          ? 'labelIndex'
                          : ''
                        : index === 4
                        ? labelIndex_4 === index2
                          ? 'labelIndex'
                          : ''
                        : '',
                    ]"
                    @click="handleLabelIndex(item, index, item2, index2)"
                  >
                    {{ item2.labelName }}
                  </li>
                </ul>
              </van-collapse-item>
            </van-collapse>
            <div class="date">
              <p>时间</p>
              <div class="start-date">
                <van-cell :title="filter.startTime" @click="showPopup(1)">
                  <template #right-icon>
                    <van-icon name="calendar-o" class="calendar-o" />
                  </template>
                </van-cell>
              </div>
              <div class="line"></div>
              <div class="end-date">
                <van-cell :title="filter.endTime" @click="showPopup(2)">
                  <template #right-icon>
                    <van-icon name="calendar-o" class="calendar-o" />
                  </template>
                </van-cell>
              </div>
            </div>
          </div>
          <div class="cancelSub">
            <van-button class="reset" type="default" @click="onCancel"> 重置 </van-button>
            <van-button type="info" block @click="onConfirm"> 确认 </van-button>
          </div>
        </van-dropdown-item>
      </van-dropdown-menu>
    </div>
    <div class="table-list" v-if="!isLimit && dataList.length > 0">
      <van-pull-refresh v-model="refreshing" success-text="刷新成功" @refresh="onRefresh">
        <van-list v-model="loading" :finished="finished" :finished-text="finishedtext" @load="onLoad">
          <van-cell v-for="item in dataList" :key="item.id" :title="item.name" @click="handleDetail(item)">
            <van-icon class="reply-open" :name="replyOpenImg" />
          </van-cell>
        </van-list>
      </van-pull-refresh>
    </div>
    <div class="noLimit" v-if="isLimit">
      <img :src="noLimitImg" alt="" />
      <p>抱歉，你无法访问改页面</p>
    </div>
    <div class="noData" v-if="!isLimit && dataList.length === 0">
      <img :src="noDataImg" alt="" />
      <p>未匹配到结果</p>
      <p>请尝试改变查询条件</p>
    </div>
    <van-popup v-model="show" position="bottom" :style="{ height: '30%' }">
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        title="选择年月日"
        @confirm="confirmDate"
        @cancel="show = false"
        :formatter="formatter"
        :min-date="minDate"
        :max-date="maxDate"
      />
    </van-popup>
  </div>
</template>
<script>
import { materialList, materialFileList, materialLabelList, materialTypeList } from "@/server/api.js";
import { addressBar, wefunstatistics, formatDate } from "@/utils/public";
import { Toast } from "vant";
export default {
  name: "materialLibrary",
  data() {
    return {
      name: "",
      filter: {
        name: "",
        pageNum: 1,
        pageSize: 9999,
        materialTypeId: "",
        labelList: [],
        type: "",
        startTime: "请选择",
        endTime: "请选择",
      },
      isLimit: false,
      finishedtext: "没有更多了",
      noLimitImg: require("../../assets/images/noLimit.png"),
      noDataImg: require("../../assets/images/no_data.png"),
      replyOpenImg: require("../../assets/images/replyopen.png"),
      show: false,
      typeIndex: 0,
      fileIndex: 0,
      labelIndex_0: 0,
      labelIndex_1: 0,
      labelIndex_2: 0,
      labelIndex_3: 0,
      labelIndex_4: 0,
      checkedList: [],
      currentDate: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()),
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(2030, 11, 31),
      activeNames: [],
      dateType: "",
      dataList: [],
      typeList: [],
      fileList: [],
      labelsList: [],
      refreshing: false,
      loading: false,
      finished: false,
      checkedLabels: [],
      windowUrl: window.location.href.split("#")[0],
    };
  },
  // created() {
  //   this.getList()
  // },
  async mounted() {
    if (localStorage.getItem("token")) {
      // wxConfig(this.windowUrl, this.jsList).then(() => {
      //   this.getList();
      // });
      // this.getList();
      await wefunstatistics("17", window.location.href.split("#")[0]);
    } else {
      addressBar("token", this.windowUrl);
    }
  },
  methods: {
    // 获取数据
    async getList() {
      this.loading = true;
      this.dataList = [];
      let params = { ...this.filter };
      if (params.startTime === "请选择") {
        params.startTime = "";
      }
      if (params.endTime === "请选择") {
        params.endTime = "";
      }
      const res = await materialList(params);
      if (res.code === "306") {
        this.isLimit = true;
        this.finishedtext = res.msg;
        this.finished = true;
        return;
      }

      if (res.code !== "200") {
        Toast.fail(res.msg);
        this.finishedtext = res.msg;
        this.finished = true;
        return;
      } else {
        this.dataList = this.dataList.concat(res.data.list);
        this.isLimit = false;
        // this.finishedtext = '没有更多了'
        if (res.data.total == 0 || res.data.total < this.filter.pageSize) {
          this.finishedtext = this.dataList.length ? "没有更多了" : "暂无话术";
          //数据全部加载完成
          this.finished = true;
          // if (scroll) {
          //   this.$nextTick(() => {
          //     window.scrollTo(0, scroll);
          //   });
          // }
        } else {
          this.finished = false;
        }
      }
    },
    async getTypeList() {
      const res = await materialTypeList();
      this.typeList = res.data.filter((k) => k.id);
      this.typeList.unshift({ id: "", name: "全部" });
    },
    // 文件
    async getFileList() {
      const res = await materialFileList();
      this.fileList = res.data.filter((k) => k.id !== "" && +k.id !== 4);
      this.fileList.unshift({ id: "", name: "全部" });
    },
    // 标签组
    async getLabelList() {
      const res = await materialLabelList();
      this.labelsList = res.data.map((item, index) => {
        item.labels.unshift({ labelId: "", labelName: "全部" });
        item.labels.forEach((k) => {
          k.groupId = item.groupId;
        });
        return item;
      });
    },
    onConfirm() {
      this.checkedList = [];
      this.filter.labelList = [];
      if (this.filter.materialTypeId) {
        this.checkedList.push(this.typeList.find((k) => k.id === this.filter.materialTypeId));
      }
      if (this.filter.type) {
        this.checkedList.push(this.fileList.find((v) => v.id === this.filter.type));
      }
      let tempArr = this.checkedLabels
        .filter((m) => m.labelId)
        .map((lab) => {
          this.filter.labelList.push(lab.labelId);
          return {
            id: lab.labelId,
            name: lab.labelName,
          };
        });
      this.checkedList.push(...tempArr);
      this.activeNames = [];
      this.getList();
      this.$refs.item.toggle();
    },
    handleIndex(type, item, index) {
      if (type === 1) {
        this.typeIndex = index;
        this.filter.materialTypeId = item.id;
      } else if (type === 2) {
        this.fileIndex = index;
        this.filter.type = item.id;
      }
    },
    onCancel() {
      this.filter.startTime = "请选择";
      this.filter.endTime = "请选择";
      this.filter.type = "";
      this.filter.labelList = [];

      this.currentDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
      this.checkedList = [];
      this.checkedLabels = [];
      this.typeIndex = 0;
      this.fileIndex = 0;
      this.labelIndex_0 = 0;
      this.labelIndex_1 = 0;
      this.labelIndex_2 = 0;
      this.labelIndex_3 = 0;
      this.labelIndex_4 = 0;
      this.activeNames = [];
      this.getList();
      this.$refs.item.toggle();
    },
    showPopup(type) {
      this.dateType = type;
      if (type === 1) {
        let dateList = this.filter.startTime.split("-");
        this.currentDate =
          this.filter.startTime !== "请选择"
            ? new Date(dateList[0], dateList[1] - 1, dateList[2])
            : new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());

        if (this.filter.endTime !== "请选择") {
          let tempEnd = this.filter.endTime.split("-");
          this.minDate = new Date(2010, 0, 1);
          this.maxDate = new Date(tempEnd[0], tempEnd[1] - 1, tempEnd[2]);
        }
      } else {
        let endTimeList = this.filter.endTime.split("-");
        this.currentDate =
          this.filter.endTime !== "请选择"
            ? new Date(endTimeList[0], endTimeList[1] - 1, endTimeList[2])
            : new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
        if (this.filter.startTime !== "请选择") {
          let tempStart = this.filter.startTime.split("-");
          this.minDate = new Date(tempStart[0], tempStart[1] - 1, tempStart[2]);
          this.maxDate = new Date(2030, 11, 31);
        }
      }
      this.show = true;
    },
    formatter(type, val) {
      if (type === "year") {
        return val + "年";
      }
      if (type === "month") {
        return val + "月";
      }
      if (type === "day") {
        return val + "日";
      }
      return val;
    },
    // 选择日期
    confirmDate(val) {
      if (this.dateType === 1) {
        this.filter.startTime = formatDate(new Date(val).getTime());
      } else {
        this.filter.endTime = formatDate(new Date(val).getTime());
      }
      this.show = false;
    },
    handleLabelIndex(item, index, item2, index2) {
      this["labelIndex_" + index] = index2;
      this.checkedLabels = [...this.checkedLabels.filter((k) => k.groupId !== item2.groupId), item2];
    },
    // 搜索
    onSearch() {
      this.filter.pageNum = 1;
      this.dataList = [];
      this.getList();
    },
    // 下拉刷新
    onRefresh() {
      // 清空列表数据
      this.dataList = [];
      this.finished = false;
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;

      // 重新加载数据

      // if(this.refreshing) {
      //   this.refreshing = false;
      // }

      this.onLoad();
    },
    onLoad() {
      if (this.refreshing) {
        this.refreshing = false;
      }
      this.pageNum++;
      this.getList();
      // this.loading = false;
      // this.finished = true;
    },
    handleDetail(row) {
      let { name, materialTypeId, labelList, startTime, type, endTime } = this.filter;
      let obj = {
        name,
        materialTypeId,
        labelList,
        startTime,
        endTime,
        type,
        typeList: this.typeList,
        fileList: this.fileList,
        labelsList: this.labelsList,

        checkedList: this.checkedList,
        labelIndex_0: this.labelIndex_0,
        labelIndex_1: this.labelIndex_1,
        labelIndex_2: this.labelIndex_2,
        labelIndex_3: this.labelIndex_3,
        labelIndex_4: this.labelIndex_4,
        typeIndex: this.typeIndex,
        fileIndex: this.fileIndex,
        activeNames: this.activeNames,
      };
      localStorage.setItem("materialobj", JSON.stringify(obj));
      this.$router.push({
        path: "/materialList",
        query: {
          id: row.id,
        },
      });
    },
  },
};
</script>
<style lang="less" scoped>
.material-library {
  padding-left: 30px;
  padding-right: 30px;
  .noLimit,
  .noData {
    text-align: center;
    img {
      padding-top: 150px;
      width: 100%;
      max-width: 320px;
      height: 100%;
    }
    p {
      color: #999;
      font-size: 26px;
    }
  }
  .van-list {
    .van-cell {
      line-height: 60px;
    }
    /deep/.van-cell__title {
      width: 80%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .van-cell__value {
      width: 100px;
    }
    /deep/.van-cell__title span {
      font-size: 26px;
    }
  }
  .search-text {
    font-size: 26px;
  }
  .van-search {
    padding: 0;
    /deep/.van-icon-search {
      font-size: 28px;
    }
    /deep/.van-field__control {
      font-size: 28px;
    }
  }
  .van-search__content {
    height: 80px;
    padding-left: 30px;
    border-radius: 40px;
    background-color: #f3f3f3;
  }
  .van-search .van-cell {
    align-items: center;
  }
  .van-field__left-icon {
    height: 80px;
  }
  .search-text {
    font-size: 32px;
    padding-left: 20px;
    cursor: pointer;
  }

  .noLimit img {
    padding-top: 100px;
  }
  .van-list {
    .reply-open {
      font-size: 16px;
    }
    .van-cell::after {
      border-bottom: 1px solid #e5e5e5;
    }
    .van-cell__title {
      font-size: 28px;
    }
    .van-cell {
      line-height: 70px;
    }
  }
  .arrow-sear {
    /deep/.van-cell__title {
      font-size: 26px;
    }
  }
  .filter-icon {
    position: absolute;
    top: 8px;
    right: 70px;
    z-index: 20;
    font-size: 30px;
  }
  /deep/ .van-dropdown-menu {
    width: 17vw;
    position: relative;
    .van-dropdown-menu__bar {
      height: 50px;
      box-shadow: none;
      .van-ellipsis {
        // height: 30px;
        padding-top: 4px;
      }
    }
    .van-dropdown-menu__item {
      justify-content: flex-end;
    }
    .van-dropdown-item__content {
      border-radius: 0 0 16px 16px;
      display: flex;
      flex-direction: column;
    }
    .van-dropdown-menu__title {
      font-size: 28px;
    }
    .van-dropdown-menu__title::after {
      display: none;
    }
  }
  .type-list,
  .file-list {
    padding: 26px 0 0 30px;
    p {
      font-size: 26px;
    }
    ul {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: wrap;
      margin-top: 24px;
      li {
        padding: 16px 24px;
        margin: 0 20px 20px 0;
        background: #f6f6f6;
        color: #98a3b3;
        font-size: 24px;
        border-radius: 4px;
      }
      .activeType,
      .activeFile {
        background: rgba(39, 127, 255, 0.13);
        color: #277fff;
      }
    }
  }
  .van-collapse {
    .van-collapse-item__content {
      padding: 0 30px;
      ul {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-wrap: wrap;
        margin-top: 24px;
        li {
          padding: 16px 24px;
          margin: 0 20px 20px 0;
          background: #f6f6f6;
          color: #98a3b3;
          font-size: 26px;
          border-radius: 4px;
        }
        .labelIndex {
          background: rgba(39, 127, 255, 0.13);
          color: #277fff;
        }
      }
    }
  }
  .condition {
    background-color: #fff;
    width: 84%;
    height: 100%;
    line-height: 67px;
    /deep/.van-tag {
      padding: 16px 24px;
      width: 120px;
      text-align: center;
      display: inline-block;
      margin-right: 20px;
      font-size: 24px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      border-radius: 4px;
    }
  }
  .date {
    margin: 26px 0 0 30px;
    p {
      font-size: 28px;
      margin-bottom: 24px;
    }
    .start-date,
    .end-date {
      width: calc((100% - 60px) / 2);
      display: inline-block;
      .van-cell {
        padding: 10px 20px;
        border: 1px solid #d8d8d8;
        border-radius: 4px;
        // width: 300px;
        font-size: 28px;
        color: #333;
        .calendar-o {
          font-size: 28px;
          line-height: inherit;
        }
        .van-icon-calendar-o:before {
          color: #666;
        }
      }
    }
    .line {
      display: inline-block;
      margin: 0 10px;
      // width: 54px;
      width: 22px;
      height: 2px;
      background-color: #d8d8d8;
    }
  }
  /deep/.van-picker__title {
    font-size: 24px;
    height: 30px;
    line-height: 30px;
  }
  .cancelSub {
    // margin-top: 50px;
    .van-button {
      width: 50%;
      display: inline-block;
    }
    .reset {
      border: none;
      background-color: #fafafa;
      color: #277fff;
    }
  }
  .search-drop {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    background-color: #fff;
    padding-bottom: 10px;
    border-bottom: 1px solid #eeeeee;
  }
}
</style>
